import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { Mode } from 'core/slices/session';
import { FlowPage } from 'core/slices/flow';
import { selectActionEditor } from 'app/components/ActionEdit/slice/selectActionEditor';
import { IActionEditorState } from 'app/components/ActionEdit/slice';
import { Flow } from 'app/components/Flow';

const page = (state: RootState) => state.flow.page;
const mode = (state: RootState) => state.session.mode;
const actionEditor = selectActionEditor;

export const selectIgnoreActions = createSelector(
  [mode, page, actionEditor],
  (mode: Mode, page: FlowPage, actionEditor: IActionEditorState) => {
    return mode === Mode.ADMIN;
  },
);
